import * as React from 'react';
import { memo } from 'react';

const SvgEmbed = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 20 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#embed_svg__a)", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" },
        React.createElement("path", { d: "M4.682 1.893.158 5.513l4.524 3.619M14.634 9.132l4.524-3.62-4.524-3.619M11.92-.368 7.396 11.846" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "embed_svg__a" },
            React.createElement("path", { fill: "#fff", transform: "translate(.158 .632)", d: "M0 0h19.684v12.838H0z" })))));
const Memo = memo(SvgEmbed);

export { Memo as default };
